module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-wrapper"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$tc('user.filter.name')
    },
    domProps: {
      "value": _vm.search
    },
    on: {
      "input": _vm.inputHandler
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2577f129"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/UserSearchInput.vue
// module id = 1025
// module chunks = 1